import { render, staticRenderFns } from "./item-provider.vue?vue&type=template&id=78a9f1b6&fddApi"
import script from "./item-provider.vue?vue&type=script&lang=js&fddApi"
export * from "./item-provider.vue?vue&type=script&lang=js&fddApi"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports